'use strict';

import newsHeader from './header/news_header.vue'
import studentStyle from './news/student_style.vue'
import courseView from './news/course_view.vue'
import schoolView from './news/school_view.vue'
import studentView from './news/student_view.vue'
import focusBar from './news/focus_side_bar.vue'
import scorllTop from './news/scroll_top.vue'
import breadCrumb from './news/bread_crumb.vue'
import pagination from './pagination.vue'


const Coms = {
    newsHeader,
    studentStyle,
    courseView,
    schoolView,
    studentView,
    focusBar,
    scorllTop,
    breadCrumb,
    pagination
  }

// vue批量引入全局组件
const PageComs = {
  install(Vue) {
    for (let key in Coms) {
      Vue.component(key, Coms[key]);
    }
  }
}

export default PageComs
